import { atom } from "jotai";
import { useMemo } from "react";
import { Planogram } from "src/components";
import { Button, Color, Flex, Icon, Skeleton, Text } from "src/elements";
import { pages, uuid } from "src/utils";
import { PlanogramMetrics } from "src/components/PlanogramExtensions/PlanogramMetrics";
import { ResponseGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_ } from "@CommonApi/merchflows/_merchflowId_/s2/_s1UserTriggerId_/s2/_templateId_";
import { routeToUrl } from "@CommonUtils/routes";
import { Pog } from "@CommonTypes/merchflow/pog/pog";
import { S2QuadLogsButton } from "./S2QuadLogsButton";

interface Props {
  merchflowId: number;
  s2Solution?: ResponseGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_[0];
}

export const OneQuadrantView = ({ merchflowId, s2Solution }: Props) => {
  const pogAtom = useMemo(() => {
    return atom(s2Solution?.status === "DONE" ? new Pog(s2Solution.solution) : null);
  }, [s2Solution]);

  const isLoading = s2Solution?.status === "NOT_STARTED" || s2Solution?.status === "IN_PROGRESS";

  return (
    <Flex key={uuid()} padding="10px" gap="10px" column>
      <Flex width="100%" flexGrow>
        {isLoading && <Skeleton width="100%" height="100%" />}

        {s2Solution?.status === "ERROR" && (
          <Flex justify="center" align="center" column gap="10px" width="100%" height="100%">
            <Icon name="alert" color={Color.red} size={32} />

            <Text variant="h4" color={Color.red}>
              Mudmap generation failed
            </Text>
          </Flex>
        )}

        {s2Solution?.status === "DONE" && (
          <Planogram pogAtom={pogAtom} isMetricsRecalculated={false} allowKonvaViewer />
        )}
      </Flex>

      {s2Solution !== undefined && (
        <Flex justify="between">
          <PlanogramMetrics pogAtom={pogAtom} size="small" isLoading={isLoading} />

          <Flex gap="8px">
            <S2QuadLogsButton
              algoRequest={s2Solution.algo_request}
              algoResponse={s2Solution.algo_response}
              error={s2Solution.error}
              s2SolutionId={s2Solution.status === "DONE" ? s2Solution.s2_solution_id : undefined}
            />

            <Button
              size="small"
              color="greenSmoke"
              isEnabled={s2Solution.status === "DONE"}
              url={
                s2Solution.status === "DONE" &&
                routeToUrl(pages.merchflows_merchflowId_S2Solution_s2SolutionId_, {
                  merchflowId,
                  s2SolutionId: s2Solution.s2_solution_id,
                })
              }
            >
              View
            </Button>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
